var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twitter-icon",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Twitter",
    d: "M14.2864 10.1637L23.222 0H21.1048L13.3421 8.82332L7.14731 0H0L9.3706 13.3428L0 24H2.1172L10.309 14.6808L16.8527 24H24L14.2864 10.1637ZM11.3852 13.4605L10.4339 12.1307L2.88108 1.56184H6.1335L12.2316 10.0942L13.1783 11.424L21.1036 22.5147H17.8512L11.3852 13.4605Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.a03c0bdededd399a900367887bf1dc53.svg";
export { ForwardRef as ReactComponent };